import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Redirect } from '@reach/router';
import { graphql, withPrefix } from 'gatsby';
export const pageQuery = graphql`
    query {
        site {
            siteMetadata {
                startPageRedirect
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};

const MDXLayout = ({
  data
}) => <Redirect noThrow to={withPrefix(data.site.siteMetadata.startPageRedirect)} />;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      